import React from 'react';
import PropTypes from 'prop-types';
import LocalizationConsumer from '../../../../l10n/localization-context';
import './slideshow-description-option.less';

const SlideShowDescriptionOption = ({ description, onChange, isHidden }) =>
{
  if (isHidden) return null;

  return (
    <div className="-wa-edit-controls__property-container">
      <div className="-wa-edit-controls__property-label -wa-edit-controls__property-label-description">
        <LocalizationConsumer id="insert-link-dialog.description-label" />
      </div>
      <div className="-wa-edit-controls__property-control">
        <textarea
          className="-wa-edit-controls__property-input -wa-edit-controls__property-tooltip-description"
          name="description"
          value={description}
          onChange={e => onChange(e.target.value)}
          maxLength="1024"
        />
      </div>
    </div>
  );
};

SlideShowDescriptionOption.propTypes = {
  description: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  isHidden: PropTypes.bool.isRequired
};

export default SlideShowDescriptionOption;